import React from "react";
import "./Button.css";

const Button = ({
	className,
	mode,
	size,
	width,
	title,
	description,
	...props
}) => {
	return (
		<button
			style={{ maxWidth: "520px" }}
			className={`Button ${mode} ${size} ${className}`}
			{...props}
		>
			{title}
			{description && <small className="tooltiptext">{description}</small>}
		</button>
	);
};

export default Button;
